import { api } from './index';

export interface BrandingMetadata {
  hasHeader: boolean;
  hasFooter: boolean;
  updatedAt: string | null;
  updatedById: string | null;
}

export interface RegulatoryClause {
  id: string;
  title: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRegulatoryClauseDto {
  title: string;
  description: string;
  sortOrder?: number;
  isActive?: boolean;
}

export interface UpdateRegulatoryClauseDto {
  title?: string;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
}

export const procurementConfigApi = {
  getBranding: async (): Promise<BrandingMetadata> => {
    const response = await api.get('/procurement-config/branding');
    return response.data;
  },

  uploadHeader: async (file: File): Promise<{ message: string; branding: BrandingMetadata }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.put('/procurement-config/branding/header', formData);
    return response.data;
  },

  uploadFooter: async (file: File): Promise<{ message: string; branding: BrandingMetadata }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.put('/procurement-config/branding/footer', formData);
    return response.data;
  },

  getHeaderImage: async (): Promise<Blob | null> => {
    try {
      const response = await api.get('/procurement-config/branding/header/image', {
        responseType: 'blob',
      });
      return response.data;
    } catch {
      return null;
    }
  },

  getFooterImage: async (): Promise<Blob | null> => {
    try {
      const response = await api.get('/procurement-config/branding/footer/image', {
        responseType: 'blob',
      });
      return response.data;
    } catch {
      return null;
    }
  },

  listClauses: async (includeInactive = false): Promise<RegulatoryClause[]> => {
    const response = await api.get('/regulatory-clauses', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data;
  },

  createClause: async (data: CreateRegulatoryClauseDto): Promise<RegulatoryClause> => {
    const response = await api.post('/regulatory-clauses', data);
    return response.data;
  },

  updateClause: async (id: string, data: UpdateRegulatoryClauseDto): Promise<RegulatoryClause> => {
    const response = await api.put(`/regulatory-clauses/${id}`, data);
    return response.data;
  },

  deleteClause: async (id: string): Promise<RegulatoryClause> => {
    const response = await api.delete(`/regulatory-clauses/${id}`);
    return response.data;
  },
};
